/**
 * Волна B (docs/MIGRATION_ROUTER.md §5). Было: <CacheDataRoute path='/shop'>.
 */
import { createFileRoute } from '@tanstack/react-router';
import CacheDataRoute from '../../CacheDataRoute';
import LandingShop from '@routes/LandingShop/component';

export const Route = createFileRoute('/shop/')({
  staticData: { layout: { landingFooter: true, withoutHeader: true, withoutFooter: true } },
  component: () => (
    <CacheDataRoute component={LandingShop} path='/shop' />
  )
});
